import React from 'react';
import PropTypes from 'prop-types';

import Map from 'components/map';
import ContentWrapper from 'components/content-wrapper';

const MapBlock = ({ map }) => {
  return (
    <div className="map-block">
      <div className="map-block__sizer">
        <ContentWrapper>{map && <Map {...map} />}</ContentWrapper>
      </div>
    </div>
  );
};

MapBlock.propTypes = {
  map: PropTypes.exact(Map.propTypes),
  theme: PropTypes.string
};

MapBlock.propTypesMeta = {
  theme: 'exclude'
};

export default MapBlock;
